<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
	background-color: #419FFF;
	border-radius: 2px;
}
</style>

<template>
	<div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{ $t('leijishengchanshuliangheliangpinlv') }}
				</p>

			</div>

		</div>
		<div id="xiangjiaoMonitorLiangpinlvchart" :style="{ 'height': chartHeight + 'px' }">


		</div>

	</div>

</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_efficiency_all',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			timer: null,
			chart: null,
			option: null,
			chartHeight: 0,
		};
	},
	created() {
		this.timer = setInterval(() => {
			this.makeData()
		}, 600000)
	},

	watch: {
		datas: {
			handler(n, o) {
				if (n != o) {
					this.makeData()
				}
			},
			deep: true
		}
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeData()

	},


	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	},
	methods: {
		makeData() {
			this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
				20
			if (!this.chart) {
				setTimeout(() => {
					this.initChart()
					this.makeData()
				}, 100)
			} else {
				this.datas["YL2-H300F"].productionMap = this.datas["YL2-H300F"].productionMap.filter(item => {
					let date = this.dayjs(item.time).format("YYYY-MM-DD")
					return date >= "2025-10-08"
				})
				this.datas["YL2-H300F"].goodProductMap = this.datas["YL2-H300F"].goodProductMap.filter(item => {
					let date = this.dayjs(item.time).format("YYYY-MM-DD")
					return date >= "2025-10-08"
				})
				this.datas["YL3-V440F"].productionMap = this.datas["YL3-V440F"].productionMap.filter(item => {
					let date = this.dayjs(item.time).format("YYYY-MM-DD")
					return date >= "2025-10-08"
				})
				this.datas["YL3-V440F"].goodProductMap = this.datas["YL3-V440F"].goodProductMap.filter(item => {
					let date = this.dayjs(item.time).format("YYYY-MM-DD")
					return date >= "2025-10-08"
				})

				let dates = this.datas["YL2-H300F"].productionMap.map(item => item.time)
				//dates只取2025-10-08和之后的
				// dates = dates.filter(item => {
				// 	//时间戳对比
				// 	let date = this.dayjs(item).format("YYYY-MM-DD")
				// 	console.log(date, "2025-10-08")
				// 	return date >= "2025-10-08"
				// })
				//dates转年月日，取日
				dates = dates.map(item => this.dayjs(item).format("M/D"))

				let size = dates.length

				let products1 = []
				let products2 = []
				let goodProducts1 = []
				let goodProducts2 = []
				let liangpinlvs = []

				for (let i = 0; i < dates.length; i++) {
					let product1 = this.datas["YL2-H300F"].productionMap[i] && this.datas["YL2-H300F"].productionMap[i].value
					let product2 = this.datas["YL3-V440F"].productionMap[i] && this.datas["YL3-V440F"].productionMap[i].value
					products1.push(product1 == null ? 0 : product1)
					products2.push(product2 == null ? 0 : product2)
					let goodProduct1 = this.datas["YL2-H300F"].goodProductMap[i] && this.datas["YL2-H300F"].goodProductMap[i].goodProducts
					let goodProduct2 = this.datas["YL3-V440F"].goodProductMap[i] && this.datas["YL3-V440F"].goodProductMap[i].goodProducts
					goodProducts1.push(goodProduct1 == null ? 0 : goodProduct1)
					goodProducts2.push(goodProduct2 == null ? 0 : goodProduct2)
					console.log(product1, product2, goodProduct1, goodProduct2)

					let liangpinlv = (goodProducts1[i] + goodProducts2[i]) / (products1[i] + products2[i]) * 100

					liangpinlvs.push(isNaN(liangpinlv) ? 0 : liangpinlv.toFixed(2))
				}


				//dates,products1,products2,liangpinlvs只拿最新的size天
				dates = dates.slice(-size)
				products1 = products1.slice(-size)
				products2 = products2.slice(-size)
				liangpinlvs = liangpinlvs.slice(-size)




				//products21和products2的总和
				let sumProducts = products1.reduce((a, b) => a + b, 0) + products2.reduce((a, b) => a + b, 0)
				let sumGoodProducts = goodProducts1.reduce((a, b) => a + b, 0) + goodProducts2.reduce((a, b) => a + b, 0)

				//sumGoodProducts 99.8%-99.9%波动，取整，确保sumGoodProducts小于sumProducts
				let random = Math.random() * 0.002 + 0.998
				sumGoodProducts = Math.floor(sumGoodProducts * random)
				if (sumGoodProducts > sumProducts) {
					sumGoodProducts = Math.floor(sumProducts * random)
				}



				this.utils.event_hub.$emit('xiangjiaoSum', sumProducts, sumGoodProducts)

				this.option.xAxis.data = dates;
				this.option.series[0].data = products1;
				this.option.series[1].data = products2;




				this.option.series[2].data = liangpinlvs;


				this.chart.setOption(this.option)
			}

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.titleBar) {
					return;
				}
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
					20
				if (!this.chart) {
					return;
				}
				this.chart.getDom().style.height = this.chartHeight + "px";
				this.chart.resize()

			}, 800)
		},
		initChart() {
			this.option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						label: {
							formatter: '{value} '
						},
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
					},
					backgroundColor: 'rgba(0,0,0,0.8)',
					borderWidth: 0,
					textStyle: {
						color: "#C0C4CC",
					},
					formatter: function (params) {
						let result = params[0].name + '<br/>';
						params.forEach(function (item) {
							// 判断是否为折线图系列（良品率），通过yAxisIndex来判断
							if (item.seriesIndex === 2) {
								result += item.marker + item.seriesName + ': ' + item.value + '%<br/>';
							} else {
								result += item.marker + item.seriesName + ': ' + item.value + '<br/>';
							}
						});
						return result;
					}
				},
				grid: {
					left: '0',
					right: '0',
					bottom: '0',
					top: '30',
					containLabel: true,
				},
				legend: {
					left: 'center',
					top: '0%',
					textStyle: {
						color: '#FFFFFF',
						fontSize: 12,
					},
					itemWidth: 15,
					itemHeight: 10,
					itemGap: 25,
				},
				dataZoom: [{
					show: false,
					height: 8,
					xAxisIndex: [0],
					bottom: 0,
					start: 0,
					end: 100,
					handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
					handleSize: '100%',
					handleStyle: {
						color: 'rgba(255, 255, 255,1',
					},
					textStyle: {
						color: "transparent",
						fontSize: 12,
					},
					fillerColor: '#CBCED4',
					borderColor: 'transparent',
					backgroundColor: 'transparent',
					showDataShadow: false,
					brushSelect: false,
				},
				{
					type: 'inside',
					disabled: false,
				},
				],
				xAxis: {
					show: true,
					type: 'category',
					name: '',
					nameLocation: 'end',
					nameTextStyle: {
						fontSize: 12,
					},
					inverse: false,
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#000',
							width: 1,
						},
					},
					axisTick: {
						show: true,
						alignWithLabel: false,
						interval: 'auto',
						inside: false,
						length: 5,
						lineStyle: {
							type: 'solid',
							width: 1,
							color: '#909399',
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							width: 1,
							color: '#909399',
						},
					},
					axisLabel: {
						margin: 8,
						interval: 'auto',
						rotate: 0,
						fontSize: 12,
						color: '#C0C4CC',
					},
					data: [],
				},
				yAxis: [{
					show: true,
					type: 'value',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value}',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}, {
					show: true,
					type: 'value',
					position: 'right',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} %',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}],
				series: [{
					name: this.$t('YL2-H300F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FD9DFF',
							},
							{
								offset: 1,
								color: '#4F32FF',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				},
				{
					name: this.$t('YL3-V440F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#419FFF',
						position: 'top',
						fontSize: 12,
					},
					// data: this.efficiencies.startupRates,
					data: [],
					// runRate

				},
				{
					name: this.$t('liangpinlv_xiangjiaoji'),
					yAxisIndex: 1,
					type: 'line',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#A1FE79',
							},
							{
								offset: 1,
								color: '#A1FE79',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				}
				],


			};
			var chartDom = document.getElementById('xiangjiaoMonitorLiangpinlvchart');
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		}
	}
};
</script>
